import { Component, type ErrorInfo, type ReactNode } from 'react';
import { leaveApp } from './unsavedCore';

type Props = { children: ReactNode; onReload?: () => void };

/**
 * Catches a crash while drawing a screen, so one broken screen shows a calm message with "Odśwież"
 * instead of blanking the whole app. Used around the whole app and around each screen in the frame.
 */
export class ErrorBoundary extends Component<Props, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Błąd ekranu', error, info.componentStack);
  }

  override render(): ReactNode {
    if (!this.state.failed) return this.props.children;
    const reload = this.props.onReload ?? (() => leaveApp(() => window.location.reload()));
    return (
      <section className="page error-screen" role="alert">
        <h1>Coś poszło nie tak</h1>
        <p>Nie udało się wyświetlić tego ekranu. Twoje dane są bezpieczne. Odśwież stronę; jeśli to się powtarza, daj znać.</p>
        <button type="button" className="btn primary" onClick={reload}>
          Odśwież
        </button>
      </section>
    );
  }
}
